import React from 'react';
import Heading from './Heading';
import { Helmet } from 'react-helmet';
import backgroundimg from "./../image/banner.png";


const CloudComputing = ({ title }) => {
    return (
        <div className="w-full h-auto bg-white flex flex-col items-center justify-center lg:mt-20 mt-0">
            <Helmet>
                <title>Cloud Computing - Nexify Infosystems</title>
                <meta name="description" content="Explore our Cloud Computing services including Cloud Strategy, Cybersecurity Solutions, Infrastructure Support, and more." />
                <meta name="keywords" content="Cloud Computing, Cloud Strategy, Cybersecurity, Infrastructure Support, Cloud Adoption, Cloud Providers, Edge Computing" />
            </Helmet>
      <div
        className="w-full h-[440px] bg-cover bg-center relative flex items-center justify-center"
        style={{ backgroundImage: `url(${backgroundimg})` }}
      >
        <div className="relative z-0 flex justify-center lg:justify-start items-center w-full px-4 sm:px-10 lg:px-20">
          <div
            className="opacity-0 translate-y-10 animate-slideUp bg-[#0e55a8] p-6 shadow-lg text-white inline-block text-center lg:text-left max-w-[90%] sm:max-w-[80%] md:max-w-[60%] lg:max-w-[60%] lg:ml-14 border border-white/20 rounded-lg relative"
            style={{
              animation: "slideUp 1s ease-in-out forwards",
              animationDelay: "2s",
            }}
          >
            {/* 🔵 Dot Pattern Overlay Inside Box */}
            <div className="absolute inset-0 bg-[radial-gradient(circle,_rgba(255,255,255,0.2)_1px,_transparent_1px)] bg-[size:6px_6px] opacity-50 pointer-events-none rounded-lg"></div>

            <h1 className="text-[8vw] md:text-[66px]  font-semibold mb-2 whitespace-nowrap">
              Nexify Cloud Computing
            </h1>
            <h2 className="text-[5vw] md:text-[40px] text-[#efefef]">
            Empowering Businesses with Next-Gen Cloud Solutions
            </h2>
          </div>
        </div>

      </div>


      <div className="w-full max-w-[1320px] px-4 mx-auto mt-10 mb-10 items-center justify-center">


            <div className="mb-2">
            <div className="flex items-center mb-2">
                    {/* <div className="h-[2px] bg-[#9fe2d8] w-8 mr-2"></div> */}
                    <p className='text-xl text-black font-[500]'>Cloud Computing </p>
                </div>
                <ul className="grid md:grid-cols-2 lg:grid-cols-3 gap-1 list-disc p-2 text-[16px]">
                    <li className="text-gray-700 p-2 hover:bg-gray-50 rounded-lg transition duration-150">Cloud Strategy</li>
                    <li className="text-gray-700 p-2 hover:bg-gray-50 rounded-lg transition duration-150">Cloud Roles, COE, Operations Models</li>
                    <li className="text-gray-700 p-2 hover:bg-gray-50 rounded-lg transition duration-150">Cloud Adoption/Business Case</li>
                    <li className="text-gray-700 p-2 hover:bg-gray-50 rounded-lg transition duration-150">Selecting Cloud Providers</li>
                    <li className="text-gray-700 p-2 hover:bg-gray-50 rounded-lg transition duration-150">Cloud Exit Strategy</li>
                    <li className="text-gray-700 p-2 hover:bg-gray-50 rounded-lg transition duration-150">Hybrid/Multicloud Strategy</li>
                    <li className="text-gray-700 p-2 hover:bg-gray-50 rounded-lg transition duration-150">Edge Computing & Emerging Technologies</li>
                    <li className="text-gray-700 p-2 hover:bg-gray-50 rounded-lg transition duration-150">IaaS Market and Workload Intelligence (Cloud Decisions)</li>
                </ul>
            </div>

            {/* Cybersecurity Solutions Section */}
            <div className="mb-2">
                 <div className="flex items-center">
                    {/* <div className="h-[2px] bg-[#9fe2d8] w-8 mr-2"></div> */}
                    <p className='text-xl text-black font-[500]'>Cybersecurity Solutions </p>
                </div>
                <ul className="grid md:grid-cols-2 lg:grid-cols-3 gap-3 list-disc p-2 text-[16px]">
                    <li className="text-gray-700 p-2 hover:bg-gray-50 rounded-lg transition duration-150">Assessing, Managing, & Prioritizing Vulnerabilities</li>
                    <li className="text-gray-700 p-2 hover:bg-gray-50 rounded-lg transition duration-150">Incident Response Programs</li>
                    <li className="text-gray-700 p-2 hover:bg-gray-50 rounded-lg transition duration-150">Security Operations Tools & Services</li>
                    <li className="text-gray-700 p-2 hover:bg-gray-50 rounded-lg transition duration-150">Threat Detection & Response</li>
                    <li className="text-gray-700 p-2 hover:bg-gray-50 rounded-lg transition duration-150">Vulnerability Management</li>
                </ul>
            </div>

            {/* Infrastructure Support Section */}
            <div className="mb-2">
                <div className="flex items-center">
                    {/* <div className="h-[2px] bg-[#9fe2d8] w-8 mr-2"></div> */}
                    <p className='text-xl text-black font-[500]'>Infrastructure Support </p>
                </div>
                <ul className="grid md:grid-cols-2 lg:grid-cols-3 gap-3 list-disc p-2 text-[16px]">
                    <li className="text-gray-700 p-2 hover:bg-gray-50 rounded-lg transition duration-150">Cloud & DC Mgmt Platforms</li>
                    <li className="text-gray-700 p-2 hover:bg-gray-50 rounded-lg transition duration-150">DevOps, PlatformOps, AIOps, SRE</li>
                    <li className="text-gray-700 p-2 hover:bg-gray-50 rounded-lg transition duration-150">Infrastructure & Application Observability</li>
                    <li className="text-gray-700 p-2 hover:bg-gray-50 rounded-lg transition duration-150">IT Service Management</li>
                    <li className="text-gray-700 p-2 hover:bg-gray-50 rounded-lg transition duration-150">Cloud Adoption & Governance</li>
                    <li className="text-gray-700 p-2 hover:bg-gray-50 rounded-lg transition duration-150">Automation Technologies</li>
                    <li className="text-gray-700 p-2 hover:bg-gray-50 rounded-lg transition duration-150">Capacity Planning/Cost Optimization</li>
                </ul>
            </div>

            {/* Application Architecture & Integration Section */}
            <div className="mb-2">
               <div className="flex items-center">
                    {/* <div className="h-[2px] bg-[#9fe2d8] w-8 mr-2"></div> */}
                    <p className='text-xl text-black font-[500]'>Application Architecture & Integration </p>
                </div>
                <ul className="grid md:grid-cols-2 lg:grid-cols-3 gap-3 list-disc p-2 text-[16px]">
                    <li className="text-gray-700 p-2 hover:bg-gray-50 rounded-lg transition duration-150">API Design/Gateway</li>
                    <li className="text-gray-700 p-2 hover:bg-gray-50 rounded-lg transition duration-150">Cloud Application Architecture</li>
                    <li className="text-gray-700 p-2 hover:bg-gray-50 rounded-lg transition duration-150">On-Prem Application Technologies</li>
                    <li className="text-gray-700 p-2 hover:bg-gray-50 rounded-lg transition duration-150">Cloud/Multicloud Application Technologies</li>
                    <li className="text-gray-700 p-2 hover:bg-gray-50 rounded-lg transition duration-150">Services, Events</li>
                    <li className="text-gray-700 p-2 hover:bg-gray-50 rounded-lg transition duration-150">Machine Learning</li>
                    <li className="text-gray-700 p-2 hover:bg-gray-50 rounded-lg transition duration-150">API Management/Mediation/Integration</li>
                    <li className="text-gray-700 p-2 hover:bg-gray-50 rounded-lg transition duration-150">Agile Connectivity Between Applications</li>
                    <li className="text-gray-700 p-2 hover:bg-gray-50 rounded-lg transition duration-150">On Premise & Cloud Integration</li>
                    <li className="text-gray-700 p-2 hover:bg-gray-50 rounded-lg transition duration-150">Integration Platforms & Technologies</li>
                </ul>
            </div>

            {/* Analytics & Artificial Intelligence Section */}
            <div className="mb-2">
            <div className="flex items-center">
                    {/* <div className="h-[2px] bg-[#9fe2d8] w-8 mr-2"></div> */}
                    <p className='text-xl text-black font-[500]'>Analytics & Artificial Intelligence </p>
                </div>
                <ul className="grid md:grid-cols-2 lg:grid-cols-3 gap-3 list-disc p-2 text-[16px]">
                    <li className="text-gray-700 p-2 hover:bg-gray-50 rounded-lg transition duration-150">Artificial Intelligence & Machine Learning</li>
                    <li className="text-gray-700 p-2 hover:bg-gray-50 rounded-lg transition duration-150">Natural Language Techniques, Text Mining, Conversational Platforms</li>
                    <li className="text-gray-700 p-2 hover:bg-gray-50 rounded-lg transition duration-150">Computer Vision, IDP</li>
                    <li className="text-gray-700 p-2 hover:bg-gray-50 rounded-lg transition duration-150">XOps-DataOps, ML Ops & ModelOps</li>
                    <li className="text-gray-700 p-2 hover:bg-gray-50 rounded-lg transition duration-150">Data Discovery, Visualization</li>
                    <li className="text-gray-700 p-2 hover:bg-gray-50 rounded-lg transition duration-150">Business Intelligence</li>
                    <li className="text-gray-700 p-2 hover:bg-gray-50 rounded-lg transition duration-150">Self-Service Analytics & Augmented Analytics</li>
                </ul>
            </div>

            {/* Digital Engineering Section */}
            <div className="mb-2">
            <div className="flex items-center">
                    {/* <div className="h-[2px] bg-[#9fe2d8] w-8 mr-2"></div> */}
                    <p className='text-xl text-black font-[500]'>Digital Engineering</p>
                </div>
                <ul className="grid md:grid-cols-2 lg:grid-cols-3 gap-3 list-disc p-2 text-[16px]">
                    <li className="text-gray-700 p-2 hover:bg-gray-50 rounded-lg transition duration-150">IoT Analytic Solutions</li>
                    <li className="text-gray-700 p-2 hover:bg-gray-50 rounded-lg transition duration-150">Edge AI</li>
                    <li className="text-gray-700 p-2 hover:bg-gray-50 rounded-lg transition duration-150">Data Management Solutions</li>
                    <li className="text-gray-700 p-2 hover:bg-gray-50 rounded-lg transition duration-150">Master Data Management Architecture</li>
                    <li className="text-gray-700 p-2 hover:bg-gray-50 rounded-lg transition duration-150">Data Governance and Information Management</li>
                    <li className="text-gray-700 p-2 hover:bg-gray-50 rounded-lg transition duration-150">Big Data Technologies & Architecture</li>
                    <li className="text-gray-700 p-2 hover:bg-gray-50 rounded-lg transition duration-150">Data Orchestration and Next Gen Integration</li>
                    <li className="text-gray-700 p-2 hover:bg-gray-50 rounded-lg transition duration-150">Data Engineering</li>
                </ul>
            </div>

            {/* Industry Solutions Section */}
            <div className="mb-2">
            <div className="flex items-center">
                    {/* <div className="h-[2px] bg-[#9fe2d8] w-8 mr-2"></div> */}
                    <p className='text-xl text-black font-[500]'>Data Management Solutions</p>
                </div>
                <ul className="grid md:grid-cols-2 lg:grid-cols-3 gap-3 list-disc p-2 text-[16px]">
                    <li className="text-gray-700 p-2 hover:bg-gray-50 rounded-lg transition duration-150">Master Data Management Architecture</li>
                    <li className="text-gray-700 p-2 hover:bg-gray-50 rounded-lg transition duration-150">Data Governance and Information Management</li>
                    <li className="text-gray-700 p-2 hover:bg-gray-50 rounded-lg transition duration-150">Big Data Technologies & Architecture</li>
                    <li className="text-gray-700 p-2 hover:bg-gray-50 rounded-lg transition duration-150">Data Orchestration and Next Gen Integration</li>
                    <li className="text-gray-700 p-2 hover:bg-gray-50 rounded-lg transition duration-150">Data Engineering, Metadata Management and Automation </li>
                    <li className="text-gray-700 p-2 hover:bg-gray-50 rounded-lg transition duration-150">Data Management-Database Storage and Architecture, Modernization</li>
                </ul>
            </div>
            </div>
        </div>
    );
};

export default CloudComputing;
